/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * RealEstateChatBotDemo | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

export interface AuthState {
  userName?: string;
  displayName?: string;
  role?: AuthStateRole;
}

export type AuthStateRole = typeof AuthStateRole[keyof typeof AuthStateRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthStateRole = {
  user: 'user',
  admin: 'admin',
} as const;

export interface AuthViewModel {
  userName?: string;
  password?: string;
}

export interface ChatBotMessage {
  role?: ChatBotRecordRole;
  message?: string;
}

export interface ChatBotRecord {
  timestamp?: number;
  role?: ChatBotRecordRole;
  message?: string;
}

export type ChatBotRecordRole = typeof ChatBotRecordRole[keyof typeof ChatBotRecordRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatBotRecordRole = {
  System: 'System',
  Tool: 'Tool',
  User: 'User',
  Assistant: 'Assistant',
} as const;

export interface ChatConfig {
  /** @nullable */
  modelId?: string | null;
  /** @nullable */
  systemName?: string | null;
  systemPrompt?: string;
  additionalPrompts?: ChatBotMessage[];
  maxHistoryRecordsCount?: number;
  temperature?: number;
  topP?: number;
}

export interface ChatInput {
  /** @nullable */
  context?: string | null;
  message?: string;
  records?: ChatBotRecord[];
}

export interface ChatResult {
  text?: string;
  records?: ChatBotRecord[];
}

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




export const getApiAuthState = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {
    
    
    return axios.get(
      `/api/Auth/State`,options
    );
  }


export const getGetApiAuthStateQueryKey = () => {
    return [`/api/Auth/State`] as const;
    }

    
export const getGetApiAuthStateQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthState>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthStateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthState>>> = ({ signal }) => getApiAuthState({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAuthStateQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthState>>>
export type GetApiAuthStateQueryError = AxiosError<unknown>



export function useGetApiAuthState<TData = Awaited<ReturnType<typeof getApiAuthState>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAuthState>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAuthStateQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteApiAuthLogout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<null>> => {
    
    
    return axios.delete(
      `/api/Auth/Logout`,options
    );
  }



export const getDeleteApiAuthLogoutMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext> => {

const mutationKey = ['deleteApiAuthLogout'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAuthLogout>>, void> = () => {
          

          return  deleteApiAuthLogout(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAuthLogout>>>
    
    export type DeleteApiAuthLogoutMutationError = AxiosError<unknown>

    export const useDeleteApiAuthLogout = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAuthLogout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAuthLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteApiAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const postApiChatChat = (
    chatInput: ChatInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatResult>> => {
    
    
    return axios.post(
      `/api/Chat/Chat`,
      chatInput,options
    );
  }



export const getPostApiChatChatMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatChat>>, TError,{data: ChatInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChatChat>>, TError,{data: ChatInput}, TContext> => {

const mutationKey = ['postApiChatChat'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChatChat>>, {data: ChatInput}> = (props) => {
          const {data} = props ?? {};

          return  postApiChatChat(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiChatChatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChatChat>>>
    export type PostApiChatChatMutationBody = ChatInput
    export type PostApiChatChatMutationError = AxiosError<unknown>

    export const usePostApiChatChat = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChatChat>>, TError,{data: ChatInput}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiChatChat>>,
        TError,
        {data: ChatInput},
        TContext
      > => {

      const mutationOptions = getPostApiChatChatMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const postApiAdminAuthLogin = (
    authViewModel: AuthViewModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AuthState>> => {
    
    
    return axios.post(
      `/api/Admin/Auth/Login`,
      authViewModel,options
    );
  }



export const getPostApiAdminAuthLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext> => {

const mutationKey = ['postApiAdminAuthLogin'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, {data: AuthViewModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminAuthLogin(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminAuthLogin>>>
    export type PostApiAdminAuthLoginMutationBody = AuthViewModel
    export type PostApiAdminAuthLoginMutationError = AxiosError<unknown>

    export const usePostApiAdminAuthLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminAuthLogin>>, TError,{data: AuthViewModel}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminAuthLogin>>,
        TError,
        {data: AuthViewModel},
        TContext
      > => {

      const mutationOptions = getPostApiAdminAuthLoginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getApiAdminChatConfigGet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatConfig>> => {
    
    
    return axios.get(
      `/api/Admin/ChatConfig/Get`,options
    );
  }


export const getGetApiAdminChatConfigGetQueryKey = () => {
    return [`/api/Admin/ChatConfig/Get`] as const;
    }

    
export const getGetApiAdminChatConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminChatConfigGet>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatConfigGet>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminChatConfigGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminChatConfigGet>>> = ({ signal }) => getApiAdminChatConfigGet({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatConfigGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminChatConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminChatConfigGet>>>
export type GetApiAdminChatConfigGetQueryError = AxiosError<unknown>



export function useGetApiAdminChatConfigGet<TData = Awaited<ReturnType<typeof getApiAdminChatConfigGet>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatConfigGet>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminChatConfigGetQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiAdminChatConfigUpdate = (
    chatConfig: ChatConfig, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<null>> => {
    
    
    return axios.put(
      `/api/Admin/ChatConfig/Update`,
      chatConfig,options
    );
  }



export const getPutApiAdminChatConfigUpdateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>, TError,{data: ChatConfig}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>, TError,{data: ChatConfig}, TContext> => {

const mutationKey = ['putApiAdminChatConfigUpdate'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>, {data: ChatConfig}> = (props) => {
          const {data} = props ?? {};

          return  putApiAdminChatConfigUpdate(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiAdminChatConfigUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>>
    export type PutApiAdminChatConfigUpdateMutationBody = ChatConfig
    export type PutApiAdminChatConfigUpdateMutationError = AxiosError<unknown>

    export const usePutApiAdminChatConfigUpdate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>, TError,{data: ChatConfig}, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiAdminChatConfigUpdate>>,
        TError,
        {data: ChatConfig},
        TContext
      > => {

      const mutationOptions = getPutApiAdminChatConfigUpdateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const putApiAdminChatConfigReset = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<null>> => {
    
    
    return axios.put(
      `/api/Admin/ChatConfig/Reset`,undefined,options
    );
  }



export const getPutApiAdminChatConfigResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigReset>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigReset>>, TError,void, TContext> => {

const mutationKey = ['putApiAdminChatConfigReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAdminChatConfigReset>>, void> = () => {
          

          return  putApiAdminChatConfigReset(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiAdminChatConfigResetMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAdminChatConfigReset>>>
    
    export type PutApiAdminChatConfigResetMutationError = AxiosError<unknown>

    export const usePutApiAdminChatConfigReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminChatConfigReset>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiAdminChatConfigReset>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPutApiAdminChatConfigResetMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getApiAdminChatListChatModelIds = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    
    return axios.get(
      `/api/Admin/Chat/ListChatModelIds`,options
    );
  }


export const getGetApiAdminChatListChatModelIdsQueryKey = () => {
    return [`/api/Admin/Chat/ListChatModelIds`] as const;
    }

    
export const getGetApiAdminChatListChatModelIdsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminChatListChatModelIdsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>> = ({ signal }) => getApiAdminChatListChatModelIds({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminChatListChatModelIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>>
export type GetApiAdminChatListChatModelIdsQueryError = AxiosError<unknown>



export function useGetApiAdminChatListChatModelIds<TData = Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiAdminChatListChatModelIds>>, TError, TData>, axios?: AxiosRequestConfig}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiAdminChatListChatModelIdsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
